import React from 'react';
import './climate.css';
import { LinearGaugeComponent, AxesDirective, AxisDirective, PointersDirective, PointerDirective, AnnotationsDirective, AnnotationDirective, Inject, Annotations,  } from '@syncfusion/ej2-react-lineargauge';
import Constants from '../../models/constants';
import Weather from '../../models/weather';

const Climate: React.FC<{weather: Weather}> = ({weather}) => {
    const airTemperature: number = weather.last5min?.airTemperature ?? 0;
    const airTemperatureStr: string = airTemperature.toFixed(1);
    const humidity: number = weather.last5min?.humidity ?? 0;
    const humidityStr: string = humidity.toFixed(0);
    const feelsLike: string = airTemperatureStr; // Todo: When the FeelsLike formula is ready. 
    return (
        <div className="climate-container">
            <div className='climate-title'>
                Climate
            </div>
            <div className='climate-gauge-pair'>
                <LinearGaugeComponent 
                    className='climate-component' 
                    container={ { width:15, type: 'Thermometer', backgroundColor: Constants.darkBlue  } } 
                    background={Constants.grey} 
                    >
                    <Inject services={[Annotations]}/>
                    <AxesDirective>
                        <AxisDirective 
                            maximum={50} 
                            minimum={-10} 
                            majorTicks={{height: 0}} 
                            minorTicks={{height: 0}} 
                            labelStyle={{font: {size: '0'}}}
                            line={{width: 0} }>
                            <PointersDirective>
                                <PointerDirective value={airTemperature} width={15} type='Bar' color={Constants.green}>
                                </PointerDirective>
                            </PointersDirective>
                        </AxisDirective>
                    </AxesDirective>
                    <AnnotationsDirective>
                        <AnnotationDirective content={'50&deg;C'} x={37} y={15} zIndex='1'>
                        </AnnotationDirective>
                    </AnnotationsDirective>
                </LinearGaugeComponent>
                <div className='climate-texts-between'>
                    <div className='big-text'>
                        Temp
                    </div>
                    <div className='bigger-text'>
                        {airTemperatureStr}&deg;C
                    </div>
                    <br />
                    <div className='big-text'>
                        Humidity
                    </div>
                    <div className='bigger-text'>
                        {humidityStr}%
                    </div>
                </div>
                <LinearGaugeComponent 
                    className='climate-component' 
                    container={ { width:15, type:'RoundedRectangle', backgroundColor: Constants.darkBlue  } } 
                    background={Constants.grey} 
                    >
                    <Inject services={[Annotations]}/>
                    <AxesDirective>
                        <AxisDirective 
                            maximum={100} 
                            minimum={0} 
                            majorTicks={{height: 0}} 
                            minorTicks={{height: 0}}
                            labelStyle={{font: {size: '0'}}}
                            line={{width: 0} }>
                            <PointersDirective>
                                <PointerDirective value={humidity} width={15} type='Bar' color={Constants.green}>
                                </PointerDirective>
                            </PointersDirective>
                        </AxisDirective>
                    </AxesDirective>
                    <AnnotationsDirective>
                        <AnnotationDirective content={'100%'} x={37} y={15} zIndex='1'>
                        </AnnotationDirective>
                    </AnnotationsDirective>
                </LinearGaugeComponent>
            </div>
            <div className='climate-feels-like'>
                {/* <span className='big-text'>Feels Like </span><span className='large-text'>{feelsLike}&deg;C</span> */}
            </div>
        </div>
    );
} 

export default Climate;